import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';

const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const { user, isAuthenticated } = usePermissions();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles.length === 0) {
    return children;
  }

  if (!allowedRoles.includes(user.role)) {
    if (user.role === 'ETUDIANT') {
      return <Navigate to="/etudiant/dashboard" replace />;
    }
    if (user.role === 'DIRECTEUR') {
      return <Navigate to="/dashboard" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PrivateRoute;

